<template>
  <div class="options order-specification">
    <div class="wrapper">
      <div class="aside">
        <div class="optionsPanel">
          <div class="optionsPanel__image">
            <img :src="getMachineImage()" class="manufacturer_image">
          </div>
          <div class="optionsPanel__content optionsPanel__content--borderTop">
            <h5>Total current cost per annum <span class="cost" v-html="$root.mnwp(order.current_costs.total_cost_per_annum.toFixed(2))"></span>
              <br>
              <span class="cost">
                  (<span v-html="$root.mnwp((order.current_costs.total_cost_per_annum / 4).toFixed(2))"></span> per quarter)
                </span>
            </h5>
            <p class="small">*Calculated using existing service costs, consumable costs, postage
              recredits, invoice fees and insurance fees
              where applicable based on information provided</p>
          </div>
        </div>
        <div class="optionsPanel" v-if="videoEmbed">
          <div class="optionsPanel__content optionsPanel__content--borderTop">
            <h5>{{ order.costs.printer.model }} demo video</h5>
            <div v-html="videoEmbed"></div>
          </div>
        </div>
        <div class="optionsPanel">
          <a @click="closeSpecification()" class="btn btn-gradient">Return To Order</a>  
        </div>
      </div>

      <div class="table">
        <features :order="order"></features>
      </div>

      <div class="close" @click="closeSpecification()"><span><i class="fa fa-times"></i></span></div>
    </div>
  </div>
</template>
<script>
  import Features from './Features.vue'

  export default {
    name: 'specification',
    props: ['order'],
    components: {
      Features,
    },
    created() {
      this.getYoutubeEmbed()
      if (this.order.quote.user.preferences) {
        this.contact_by_email = this.order.quote.user.preferences.preferences_email
        this.contact_by_phone = this.order.quote.user.preferences.preferences_phone
        this.contact_by_post = this.order.quote.user.preferences.preferences_mail
      }
    },
    data() {
      return {
        videoEmbed: null,
        contact_by_email: false,
        contact_by_phone: false,
        contact_by_post: false,
      }
    },
    methods: {
      getYoutubeEmbed() {
        let youTubeUrl = this.order.costs.printer.video_url
        let youTubeId
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
        let match = youTubeUrl.match(regExp)
        if (match && match[2].length == 11) {
          youTubeId = match[2]
        } else {
          youTubeId = false
        }
        let embed = false
        if (youTubeId) {
          embed = '<iframe width="100%" height="auto" src="//www.youtube.com/embed/' + youTubeId + '" frameborder="0" allowfullscreen></iframe>'
        }
        this.videoEmbed = embed
      },
      getMachineImage() {
        return '/static/styles/mailkit/img/printers/' + this.order.costs.printer.image_url
      },
      closeSpecification() {
        this.$parent.showSpecification = false
      },
      toggleRadio(name) {
        $('input.' + name).trigger('click');
      },
      submitOrder() {
        this.$parent.submitOrder()
      }
    }
  }
</script>

<style lang="scss">
  .order-specification {
    z-index: 5;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-bottom: 100px;
    overflow: hidden;
    visibility: hidden;
    transition: visibility 0s 0.5s;

    &.isActive {
      visibility: visible;
      transition: none;

      &:before {
        opacity: 1;
      }

      .wrapper {
        left: 10%;
      }
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#fff, 0.5);
      opacity: 0;
      transition: opacity 0.5s;
      content: '';
    }

    .wrapper {
      z-index: 2;
      position: relative;
      display: flex;
      background-color: #fff;
      width: 90%;
      left: 100%;
      transition: left 0.5s;

      @media screen and (max-width: 1023px) {
        flex-direction: column;
      }

      .close {
        position: absolute;
        top: 10px;
        left: -17.5px;
        border: 5px solid #fff;
        border-radius: 100%;
        cursor: pointer;

        span {
          display: block;
          width: 30px;
          height: 30px;
          line-height: 30px;
          border-radius: 100%;
          background: #0a70e3;
          background: linear-gradient(45deg, #0a70e3 0%, #f81e8c 100%);
          text-align: center;
          font-size: 18px;
          font-weight: 700;
          color: #fff;
        }
      }

      .aside {
        flex: 0 1 40%;
        border: 2px solid #ccc;
        border-right: none;

        @media screen and (max-width: 1023px) {
          padding-bottom: 20px;
          border: 1px solid #ccc;
          border-bottom: none;
        }
      }

      .table {
        flex: 0 1 60%;
        line-height: 1.5;

        .infoContent {
          line-height: 1.8;
        }

        th {
          vertical-align: middle;

          &:last-child {
            border-right: 1px solid #2B72DC;
          }
        }
      }
    }

    .optionsPanel {
      padding-top: 0;
      border: none;
    }

    .optionsPanel__content {
      .small {
        line-height: 1.5;
      }
    }

    .optionsPanel__image {
      img {
        max-width: 75%;
      }
    }

    iframe {
      margin-top: 10px;
      height: 300px;
    }

    .submitPanel {
      padding: 30px 15px;
      border-top: 1px solid #ccc;
      text-align: center;

      h5 {
        margin-top: 0;
      }

      input.marketing {
        margin-bottom: 10px;
      }

      .small {
        line-height: 1.5;
      }

      .frmInline span {
        font-size: 14px;
      }
    }
  }
</style>

<style scoped lang="scss">
  @media screen and (max-width: 1023px) {
    .order-specification {
      position: absolute;
      display: none;

      &.isActive {
        display: block;
      }

      .wrapper {
        left: 0;
        width: 100%;
      }

      .close {
        left: 10px;
      }
    }

    .frmInline .termsAgreement {
      display: flex;
      align-items: center;

      input {
        flex: 0 0 30px;
        margin-top: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Order/specification/Specification.vue